module.exports = __webpack_public_path__ + "855df726f09c258bd416e28b7f98002b.svg";